import styled from '@emotion/styled'
import { Card, CardContent, Grid, Typography } from '@mui/material'
import {
	ButtonImageryPickerProps,
	ButtonImageryProps,
} from './ImageryPicker.types'

export const ButtonImageryPicker = styled('button')<ButtonImageryPickerProps>`
	position: absolute;
	border: 2px solid #aaa;
	cursor: pointer;
	overflow: hidden;
	width: 50px;
	height: 50px;
	border-radius: 14%;
	left: 20px;
	bottom: 50px;

	border-color: ${(props) => (props.openImageryPicker ? '#4cb691' : '#aaa')};

	&:hover {
		color: #fff;
		fill: #fff;
		background: #48b;
		border-color: #0073a9;
		box-shadow: 0 0 8px #fff;
	}
`

export const ButtonImagery = styled(ButtonImageryPicker)<ButtonImageryProps>`
	position: relative;
	width: 60px;
	height: 60px;
	top: unset;
	right: unset;
	left: unset;
	bottom: unset;

	border-color: ${(props) => (props.selected ? '#4cb691' : '#aaa')};
	box-shadow: ${(props) => (props.selected ? '0 0 4px #4cb691' : 'none')};

	&:hover {
		box-shadow: 0 0 4px #0073a9;
	}
`

export const Image = styled('img')`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	border: none;
`

export const Panel = styled(Card)`
	position: absolute;
	width: 185px;
	left: 90px;
	bottom: 50px;
	border-radius: 10px;
`

export const SubTitle = styled(Typography)`
	background: linear-gradient(to left, #4cb691 10%, #0073a9) no-repeat;
	font-family: 'Source Sans Pro', sans-serif;
	text-transform: uppercase;
	color: white;
	font-size: 16px;
	height: 26px;
	padding: 8px 0px 6px 8px;
	margin: 0;
`

export const CardContentImagery = styled(CardContent)`
	margin-bottom: 0;
`

export const GridImagery = styled(Grid)`
	margin-left: 0px;
	margin-bottom: 16px;
	width: 100%;
`
